export default __webpack_public_path__ + "8bf30aa670a798f1dc700cd759bcb0de.woff2";